import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";
import nsccImg from "../assets/nscc-logo.jpg";
import codsoftImg from "../assets/codsoft.png";

const experiences = [
  {
    id: 1,
    image: nsccImg,
    title: "Newton School Coding Club (NSCC)",
    date: "FEB 2023 - PRESENT",
    description: `Core member of the technical society of BPIT. I conduct sessions, contests, and technical challenges.`,
    link: {
      text: "here",
      href: "https://bpit.namespacecomm.in/",
    },
  },
  {
    id: 2,
    image: codsoftImg,
    title: "CodSoft – Frontend Intern",
    date: "AUG 2023 - SEPT 2023",
    description:
      "Developed a portfolio website, landing page, and calculator using HTML, CSS, and JavaScript.",
    link: {
      text: "LinkedIn",
      href: "https://www.linkedin.com/in/gauranshgoel123/",
    },
  },
];

const Experience = () => {
  return (
    <section id="experience" className="pt-32 pb-16 px-6 md:px-16">
      {/* Heading */}
      <motion.div
        className="md:w-2/4 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <p className="font-playfair font-semibold text-4xl text-red">
          EXPERIENCE
        </p>
        <LineGradient width="mt-3 mx-auto w-60" />
        
        <p className="mt-10 mb-10">
          Here are some of my Experiences:
        </p>
      </motion.div>

      {/* Cards */}
      <div className="grid md:grid-cols-2 gap-12 place-items-center">
        {experiences.map((exp, index) => (
          <motion.div
            key={exp.id}
            className="relative w-full max-w-[400px] p-6 rounded-2xl shadow-lg border border-white/30 bg-white/10 backdrop-blur-md hover:scale-105 transition-transform duration-300 flex flex-col items-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
          >
            {/* Image */}
            <div className="w-[100px] h-[100px] mb-4">
              <img
                src={exp.image}
                alt={exp.title}
                className="rounded-full w-full h-full object-cover border-2 border-white/40 shadow-md"
              />
            </div>

            {/* Date */}
            <p className="text-sm text-gray-200 font-semibold text-center">
              {exp.date}
            </p>

            {/* Title */}
            <h3 className="text-xl font-semibold text-white text-center mt-2">
              {exp.title}
            </h3>

            {/* Description */}
            <p className="text-gray-200 text-center text-sm mt-3">
              {exp.description}{" "}
              {exp.link && (
                <a
                  href={exp.link.href}
                  className="text-blue-300 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {exp.link.text}
                </a>
              )}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
